__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-07-13-1783953679-stable-dev/";